module.exports = __webpack_public_path__ + "assets/img/1d93a888e93afca48aaf9ed54882d48c.png";